/**
 * A picker's dropdown, for pointer-sized screens (BON-534).
 *
 * Chrome only — the rows are the caller's, so the scope picker's regions and
 * the nav's app modes open the same panel in the same place rather than being
 * two people's idea of a menu. The phone gets `ScopeSheet` instead: this panel
 * is anchored to its trigger and runs off the right of a narrow screen.
 */
import type { ReactNode } from 'react';

export interface ScopeMenuProps {
  children: ReactNode;
}

export function ScopeMenu({ children }: ScopeMenuProps) {
  return (
    <div
      role="menu"
      style={{
        position: 'absolute',
        top: 'calc(100% + 0.5rem)',
        left: 0,
        zIndex: 60,
        minWidth: '22rem',
        maxHeight: '26rem',
        overflow: 'auto',
        background: 'var(--nb-bg)',
        border: '1px solid var(--nb-border)',
        borderRadius: 10,
        boxShadow: '0 14px 36px -10px rgba(0,0,0,.28)',
        padding: '0.4rem',
      }}
    >
      {children}
    </div>
  );
}
